export type { BatchLoadFn, CacheMap, Options } from "dataloader";

export { default } from "dataloader";
